export default "__VITE_ASSET__Drk1XqK3__"